import store from '../store'
export function resize() {
  const width = window.innerWidth
  store.commit('setWidth', width)
}
window.onresize = resize
